import React from 'react';
import MUIIconButton, { IconButtonProps as MUIIconButtonProps } from '@mui/material/IconButton';
import { ButtonPropsOverride } from '../button';

export type IconButtonProps = Omit<MUIIconButtonProps, 'onClick'> & ButtonPropsOverride;

const IconButton: React.FC<IconButtonProps> = (props) => {
  return <MUIIconButton {...props} />;
};

export default IconButton;
